export class AlgoliaUtils {
  static get TAX_RATE() {
    return 1 + (window.algoliaConfig?.taxRate || (window.settings?.mwst_value || 19) / 100);
  }
  // Helper function to format price using Shopify's locale and currency settings
  static formatPrice(price, includeCurrency = false) {
    // Get locale from Shopify settings
    const locale = window.Shopify?.locale;

    // Get currency from Shopify settings
    const currency = window.Shopify?.currency?.active;

    if (!locale || !currency) {
      console.warn('Shopify locale or currency not available');
      return price.toFixed(2);
    }

    const formatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...(includeCurrency && { style: 'currency', currency }),
    });

    return formatter.format(price);
  }
  // Helper function to get currency symbol from Shopify settings
  static getCurrencySymbol() {
    const currency = window.Shopify?.currency?.active;
    if (!currency) {
      console.warn('Shopify currency not available');
      return '';
    }

    // Use proper symbols for currencies
    if (currency === 'EUR') {
      return '€';
    }

    return window.algoliaConfig?.currency || currency;
  }
  // Helper function to format price with currency in correct position
  static formatPriceWithCurrency(price) {
    const formattedPrice = AlgoliaUtils.formatPrice(price);
    const currencySymbol = AlgoliaUtils.getCurrencySymbol();

    if (!currencySymbol) return formattedPrice;

    // CHF goes before the price, € and most others go after
    if (currencySymbol === 'CHF') {
      return `${currencySymbol} ${formattedPrice}`;
    }

    return `${formattedPrice} ${currencySymbol}`;
  }
  static logError(error, context) {
    const errorObj = error instanceof Error ? error : new Error(error);
    console.error(`[AlgoliaSearch][${context}]:`, errorObj);
  }
}
